<div class="publisher-container" [ngClass]="{'publishing': publishing}" #publisherDiv>
  <i class="publisher-miniature icon-miniature" (click)="toggleFullScreenPublisher()"></i>
</div>
<!-- AÑADIR CLASE setting-btn-position__recording CUANDO ESTÉ GRABANDO  -->
<div class="setting-btn-position fixed_buttons" [ngClass]="{'setting-btn-position__recording': recording}">
  @if(settingsList){    
    <div  class="setting-btn-container u-flex">
      @for(settingsBtn of settingsList; track $index){
        <div class="setting-btn" [ngClass]="{'disabled': !settingsBtn.supported}" (click)="settingsBtn.fn(publisher)">
          <div class="setting-btn-btn">
            <i [ngClass]="'icon-' + settingsBtn.icon"></i>
          </div>
          @if(hasMsgs && settingsBtn.icon === 'chat'){
            <!-- CHAT NOTIFICATION -->
            <div class="notification"></div>
          }
        </div>
      }
      @if(moreSettingsList.length){
      
        <div class="setting-btn more-btn">
          <div class="setting-btn-btn" (click)="moreSettings = !moreSettings">
            <i class="icon-show_more"></i>
          </div>
          @if(moreSettings){   
            <div class="box more-btn-list">
              <ul class="noselect">
                @for( moreSettingsBtn of moreSettingsList; track $index; let i = $index){
                  <li 
                    (click)="moreSettingsBtn.fn(i)"
                    [ngClass]="{'show-video-list': showVideoList && moreSettingsBtn.name === 'Iniciar grabación'}">
                    <i [ngClass]="'icon-' + moreSettingsBtn.icon"></i>
                    <span>{{ moreSettingsBtn.name }}</span>
                    @if(moreSettingsBtn.name === 'Iniciar grabación'){
                      <div>
                        <sas-rec-video [switchCameraSupported]="switchCameraSupported"
                          [screenSharedSupported]="screenSharingSupported" [showTooltip]="showTooltip && canShowTooltip"
                          [showVideoList]="showVideoList" (closePopUp)="videoPopUpClosed()"
                          (showBtnStopRecord)="showButtonStopRecord($event)">
                        </sas-rec-video>
                      </div>
                    }
        
                  </li>
                }
              </ul>
            </div>
          }
          @if(suggestions){
            <div class="form-container box">
              <div class="tooltip-inner">
                <div class="title" [translate]="'VIDEO.VIDEO_LIST.TITLE'"></div>
                <div class="subtitle" [translate]="'VIDEO.VIDEO_LIST.SUBTITLE'"></div>
                <div class="video-container">
                  <div class="tooltip-video-row">
                    <div class="tooltip-video-name"></div>
                    <div class="tooltip-video-icons">
                      <i class="icon-download"></i>
                      <i class="icon-trash"></i>
                    </div>
                  </div>
                </div>
      
                <div class="u-flex u-flex-justify-content-end">
                  <button class="btn btn-primary btn-lg" [translate]="'HEADER.INVITE_FORM.BUTTONS.CANCEL'"
                    (click)="cancel($event)"></button>
                </div>
              </div>
            </div>
          }
        </div>
      }
      @if(recording){
      <div class="record-container" (click)="stopRecord()">
        <i class="icon-record-off"></i>
        <div class="record-container-txt" [translate]="'VIDEO.STOP_RECORD_BUTTON'"></div>
      </div>
      }
  
    </div>
  }
</div>
